// extracted by css-extract-rspack-plugin
module.exports =  {"root":"DocumentCount__root____wN8m","title":"DocumentCount__title___bK05I","count":"DocumentCount__count___LbKeg"};